
















import Vue, { PropType } from 'vue';
import { Module } from '@/models/configurator/module';

export default Vue.extend({
  name: 'ModuleArchiveBanner',

  props: {
    module: {
      type: Object as PropType<Module>
    }
  }
});
